import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/stapleFoodGrain",
    name: "stapleFoodGrain",
    component: () => import("@/views/productCenter/one.vue"),
  },
  {
    path: "/snackSeries",
    name: "snackSeries",
    component: () => import("@/views/productCenter/two.vue"),
  },
  {
    path: "/suppliesSeries",
    name: "suppliesSeries",
    component: () => import("@/views/productCenter/three.vue"),
  },
  {
    path: "/nutritionHealthCare",
    name: "nutritionHealthCare",
    component: () => import("@/views/productCenter/four.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/about_us/about.vue"),
  },
  {
    path: "/brandDynamics",
    name: "brandDynamics",
    hidden: true,
    component: () => import("@/views/brand_dynamics/brandDynamics.vue"),
  },
  {
    path: "/brandDynamicsListed",
    name: "brandDynamicsListed",
    hidden: true,
    component: () => import("@/views/brand_dynamics/one.vue"),
  },
  {
    path: "/brandDynamicsPetShow",
    name: "brandDynamicsPetShow",
    hidden: true,
    component: () => import("@/views/brand_dynamics/two.vue"),
  },

  {
    path: "/brandDynamicsAnnualAwardsCeremony",
    name: "brandDynamicsAnnualAwardsCeremony",
    hidden: true,
    component: () => import("@/views/brand_dynamics/three.vue"),
  },
  {
    path: "/brandDynamicsAsianPetExhibition",
    name: "brandDynamicsAsianPetExhibition",
    hidden: true,
    component: () => import("@/views/brand_dynamics/four.vue"),
  },
  {
    path: "/brandDynamicsDonation",
    name: "brandDynamicsDonation",
    hidden: true,
    component: () => import("@/views/brand_dynamics/five.vue"),
  },
  {
    path: "/goldMedal",
    name: "goldMedal",
    hidden: true,
    component: () => import("@/views/brand_dynamics/six.vue"),
  },
  {
    path: "/seven",
    name: "seven",
    hidden: true,
    component: () => import("@/views/brand_dynamics/seven.vue"),
  },
  {
    path: "/eight",
    name: "eight",
    hidden: true,
    component: () => import("@/views/brand_dynamics/eight.vue"),
  },
  {
    path: "/jinnuo",
    name: "jinnuo",
    hidden: true,
    component: () => import("@/views/brand_dynamics/jinnuo.vue"),
  },
  {
    path: "/ten",
    name: "ten",
    hidden: true,
    component: () => import("@/views/brand_dynamics/ten.vue"),
  },
  {
    path: "/threeAuthoritativeCertifications",
    name: "threeAuthoritativeCertifications",
    hidden: true,
    component: () =>
      import("@/views/brand_dynamics/threeAuthoritativeCertifications.vue"),
  },
  {
    path: "/DedicatedNewHeight",
    name: "DedicatedNewHeight",
    hidden: true,
    component: () => import("@/views/brand_dynamics/DedicatedNewHeight.vue"),
  },
  {
    path: "/authoritativeCertification",
    name: "authoritativeCertification",
    hidden: true,
    component: () =>
      import("@/views/brand_dynamics/authoritativeCertification.vue"),
  },
  {
    path: "/fiveMajorCertifications",
    name: "fiveMajorCertifications",
    hidden: true,
    component: () =>
      import("@/views/brand_dynamics/fiveMajorCertifications.vue"),
  },
  {
    path: "/sales",
    name: "sales",
    hidden: true,
    component: () => import("@/views/brand_dynamics/sales.vue"),
  },
  {
    path: "/investigated",
    name: "investigated",
    hidden: true,
    component: () => import("@/views/brand_dynamics/investigated.vue"),
  },
  {
    path: "/community",
    name: "community",
    hidden: true,
    component: () => import("@/views/brand_dynamics/community.vue"),
  },
  {
    path: "/eighthAnniversary",
    name: "eighthAnniversary",
    hidden: true,
    component: () => import("@/views/brand_dynamics/eighthAnniversary.vue"),
  },
  {
    path: "/sixNationalCertifications",
    name: "sixNationalCertifications",
    hidden: true,
    component: () =>
      import("@/views/brand_dynamics/sixNationalCertifications.vue"),
  },
  {
    path: "/twenty",
    name: "twenty",
    hidden: true,
    component: () => import("@/views/brand_dynamics/twenty.vue"),
  },
  {
    path: "/twentyOne",
    name: "twentyOne",
    hidden: true,
    component: () => import("@/views/brand_dynamics/twentyOne.vue"),
  },
  {
    path: "/twentyTwo",
    name: "twentyTwo",
    hidden: true,
    component: () => import("@/views/brand_dynamics/twentyTwo.vue"),
  },
  {
    path: "/twentyThree",
    name: "twentyThree",
    hidden: true,
    component: () => import("@/views/brand_dynamics/twentyThree.vue"),
  },
  {
    path: "/twentyThird",
    name: "twentyThird",
    hidden: true,
    component: () => import("@/views/brand_dynamics/twentyThird.vue"),
  },
  {
    path: "/twentyFour",
    name: "twentyFour",
    hidden: true,
    component: () => import("@/views/brand_dynamics/twentyFour.vue"),
  },
  {
    path: "/contactUs",
    name: "contactUs",
    hidden: true,
    component: () => import("@/views/contact_us/contactUs.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }; // 每次页面导航后都滚动到顶部
  },
});

export default router;
